<template>
  <div class="page-wrapper bg-white min-h-screen">
    <header class="sticky pin-t">
      <div class="blue-gradient hat relative"/>
      <Nav />
    </header>

    <main class="bg-white z-0">
      <router-view></router-view>
    </main>

    <Footer />
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'

export default {
  components: {
    Nav,
    Footer
  },
  mounted() {
    this.$store.dispatch('loadCart')
  }
}
</script>

<style>
@tailwind preflight;
@tailwind components;
@tailwind utilities;
</style>

<style lang="scss">
@import "./assets/styles.scss";

.page-wrapper {
  display: grid;
  grid-template-rows: auto 1fr auto;
}

.hat {
  height: 6px;
  z-index: 15;
}

header {
  background: rgba(255,255,255,0.98);
  z-index: 999;
  @supports (backdrop-filter: blur(5px)) {
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(5px);
  }
}
@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }

  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
</style>
